import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[capsLockOn]'
})

export class CapsLockOnDirective {

  @Output()
  public capsLockOn = new EventEmitter();

  @HostListener('document:keyup', ['$event'])
  public onKeyup(event: KeyboardEvent) {
    this.checkCapsLock(event);
  }

  @HostListener('document:keydown', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    this.checkCapsLock(event);
  }

  private checkCapsLock(event) {
    let caps = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLockOn.emit(caps);
  }

}
